'use strict';

var cov_2kwhanbluk = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/newExecutionModal/newExecutionModal.js',
        hash = 'af222270cb3fe04531a05be3227573b9438e8457',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/newExecutionModal/newExecutionModal.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 36,
                    column: 12
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 71
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 22
                },
                end: {
                    line: 10,
                    column: 26
                }
            },
            '3': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 18,
                    column: 10
                }
            },
            '4': {
                start: {
                    line: 12,
                    column: 12
                },
                end: {
                    line: 17,
                    column: 15
                }
            },
            '5': {
                start: {
                    line: 23,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 65
                }
            },
            '6': {
                start: {
                    line: 24,
                    column: 8
                },
                end: {
                    line: 24,
                    column: 97
                }
            },
            '7': {
                start: {
                    line: 26,
                    column: 8
                },
                end: {
                    line: 28,
                    column: 10
                }
            },
            '8': {
                start: {
                    line: 27,
                    column: 12
                },
                end: {
                    line: 27,
                    column: 31
                }
            },
            '9': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 34,
                    column: 10
                }
            },
            '10': {
                start: {
                    line: 31,
                    column: 12
                },
                end: {
                    line: 33,
                    column: 15
                }
            },
            '11': {
                start: {
                    line: 32,
                    column: 16
                },
                end: {
                    line: 32,
                    column: 42
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 36,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'NewExecutionModalService',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 50
                    },
                    end: {
                        line: 19,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 11,
                        column: 23
                    },
                    end: {
                        line: 11,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 11,
                        column: 35
                    },
                    end: {
                        line: 18,
                        column: 9
                    }
                },
                line: 11
            },
            '3': {
                name: 'NewExecutionModalController',
                decl: {
                    start: {
                        line: 22,
                        column: 13
                    },
                    end: {
                        line: 22,
                        column: 40
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 104
                    },
                    end: {
                        line: 35,
                        column: 5
                    }
                },
                line: 22
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 26,
                        column: 29
                    },
                    end: {
                        line: 26,
                        column: 30
                    }
                },
                loc: {
                    start: {
                        line: 26,
                        column: 41
                    },
                    end: {
                        line: 28,
                        column: 9
                    }
                },
                line: 26
            },
            '5': {
                name: '(anonymous_5)',
                decl: {
                    start: {
                        line: 30,
                        column: 33
                    },
                    end: {
                        line: 30,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 30,
                        column: 45
                    },
                    end: {
                        line: 34,
                        column: 9
                    }
                },
                line: 30
            },
            '6': {
                name: '(anonymous_6)',
                decl: {
                    start: {
                        line: 31,
                        column: 46
                    },
                    end: {
                        line: 31,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 31,
                        column: 67
                    },
                    end: {
                        line: 33,
                        column: 13
                    }
                },
                line: 31
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_2kwhanbluk.s[0]++;
(function () {
    'use strict';

    cov_2kwhanbluk.f[0]++;
    cov_2kwhanbluk.s[1]++;
    angular.module('app').service('NewExecutionModalService', NewExecutionModalService);

    /* @ngInject */
    function NewExecutionModalService($mdDialog) {
        cov_2kwhanbluk.f[1]++;

        var Service = (cov_2kwhanbluk.s[2]++, this);
        cov_2kwhanbluk.s[3]++;
        this.display = function () {
            cov_2kwhanbluk.f[2]++;
            cov_2kwhanbluk.s[4]++;

            return $mdDialog.show({
                templateUrl: 'app/components/newExecutionModal/newExecutionModal.html',
                controller: NewExecutionModalController,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };
    }

    /* @ngInject */
    function NewExecutionModalController($scope, $mdDialog, ExecutionsTable, NewExecutionModalService) {
        cov_2kwhanbluk.f[3]++;
        cov_2kwhanbluk.s[5]++;

        this.NewExecutionModalService = NewExecutionModalService;
        cov_2kwhanbluk.s[6]++;
        $scope.newExecution = ExecutionsTable.$build({ task: this.NewExecutionModalService.task });

        cov_2kwhanbluk.s[7]++;
        $scope.closeDialog = function () {
            cov_2kwhanbluk.f[4]++;
            cov_2kwhanbluk.s[8]++;

            $mdDialog.cancel();
        };

        cov_2kwhanbluk.s[9]++;
        $scope.createExecution = function () {
            cov_2kwhanbluk.f[5]++;
            cov_2kwhanbluk.s[10]++;

            $scope.newExecution.$save().$then(function (execution) {
                cov_2kwhanbluk.f[6]++;
                cov_2kwhanbluk.s[11]++;

                $mdDialog.hide(execution);
            });
        };
    }
})(angular);